<template lang="pug">
    v-container(grid-list-lg, text-xs-center)
      v-flex(xs12 sm6 md6 style='margin:10px auto; background-color:white' class="elevation-2")
        v-card
          v-card-title(style='margin:0 auto')
            span(class="text-center") Seleccione su Empresa
          v-layout(align-center='', justify-center='', row='', wrap fill-height='')
            v-flex(xs10)
              v-select(v-model="model.idempresa" dense outlined
                  :items="idEmpresaArray"
                  label="Empresa")
          v-flex(xs12, style='margin-bottom:20px;margin-top:10px')
            v-layout(align-center='', justify-center='', row='', wrap fill-height='')
              v-btn(color="error" class="my-5 mx-3" dark @click.native='logout()') Volver
              v-btn(color="success" class="my-5 mx-3" dark @click.native='aceptar()') Aceptar

</template>

<script>
import Api from '@/services/methods'
export default {
  data: () => ({
    dialog: false,
    empresa: [],
    idEmpresaArray: [],
    model: {
      idempresa: ''
    }
  }),

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    if (this.$store.state.usuario.master) {
      this.master = this.$store.state.usuario.master
    } else {
      this.master = this.$store.state.usuario._id
    }
    this.initialize()
  },

  methods: {
    initialize () {
      this.getEmpresas()
    },

    getEmpresas () {
      Api.get('empresa/all')
            .then(res => {
              res.data.map(empresa => {
                this.idEmpresaArray.push({ text: empresa.nombre, value: empresa._id})
              })
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al cargar',
                  //text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message);
              }
            })
    },

    logout () {
      this.$swal({
        icon: 'warning',
        title: '¿Seguro que desea Salir?',
        text: 'No podrá revertir',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Salir'
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('logout')
          this.$cookies.remove('token')
          this.$cookies.remove('log')
          window.location.href = '/Login'
        }
      })
    },
    aceptar () {
      if (this.model.idempresa) {
        Api.post('/login/select', this.model)
          .then(res => {
            if (res.data.status === 'Success') {
              this.$store.dispatch('config', res.data.config)
              if (res.data.empresa.logo64) {
                this.$store.dispatch('logo64', res.data.empresa.logo64.base64)
              }
              this.$store.dispatch('empresa', this.model)
              this.$cookies.set('token', res.data.token, '5D', '')
              this.$cookies.set('log', 'lleno')
              window.location.href = '/home'
            } else {
              this.$swal(
                'Oops...',
                'Empresa no encontrada, revise su informacion',
                'error'
              )
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  }
}
</script>
